import { settings } from "pixi.js";
import { element } from "svelte/internal";
import { ISystemContext } from "./Context/SystemContext";
import { ITimeout } from "./Context/Timeout";
import { ButtonState } from "./IO";
import { AddMouseDownListener, AddMouseUpListener, CreateElement, Log, Scale, SetStyles ,MyPIXIContainer } from "./MyHelpers";
import { ImageResource } from "./ResourceManager/ImageResource";
import { Resourceful } from "./ResourceManager/Resourceful";
import { ResourceIdentifier } from "./ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "./ResourceManager/ResourceManager";
import { ZIndex } from "./ZIndex";
import { Settings } from "./Settings";

export interface IPopupMessage
{
	Title: string;
	Text: string;	
	Buttons : MessageButton[];
	DisplayType : DisplayType;
}

export enum DisplayType {
	Notification,
	PopUp,
}

export enum LinkType {
	Disable,
	Redirect,
	Ajax,
	AjaxReponse,
}

export interface MessageButton
{
  Text: string;
  Action: string;
  Link: string;
  LinkType: LinkType;
}


export interface ButtonStatePopupMessage
{
    
	element : HTMLElement;	
	isPressed: boolean;
	delayReleaseTime: ITimeout;
    releasePending: boolean;   
}

export const PopupAvailableButtons = {
    Close: "Close",
    Continue: "Continue",
   
} as const;

export type PopupAvailableButtons = typeof PopupAvailableButtons[keyof typeof PopupAvailableButtons];

export class PopupMessage implements Resourceful
{
	private resourcesBasePath: string;
	private  view: HTMLElement = null;
	private dialog: HTMLElement = null;
	private resid: ResourceIdentifier = null;
	private containerButtons : HTMLElement = null;
	private advertismentheader: HTMLElement = null; 

	private titleContainer: HTMLElement = null;
	private controls: HTMLElement = null;
	private reasonContainer: HTMLElement = null;
	protected isLocked:boolean = false;
	protected systemContext: ISystemContext;
    protected commonBonusResourcesBasePath: string = Settings.ResourcesFolder + "multigame/multigame/img/";
	protected buttonState: Map<MessageButton, ButtonStatePopupMessage> = new Map<MessageButton, ButtonStatePopupMessage>();

    protected homeUrl: string;
    public SetHomeUrl(url: string): void
    {
        this.homeUrl = url;
    }


    protected cashierUrl: string;
    public SetCashierUrl(url: string): void
    {
        this.cashierUrl = url;
    }

    protected historyUrl: string;
    public SetHistoryUrl(url: string): void
    {
        this.historyUrl = url;
    }

	public constructor(resid: ResourceIdentifier, resourcesBasePath: string , systemContext:ISystemContext )
	{
		this.resid = resid.Add("PopupMessage");
		this.resourcesBasePath = resourcesBasePath;

		this.systemContext = systemContext.CreateSubContext("PopupMessage");

		this.view = document.createElement("div");
		this.view.classList.add(this.resid.Scope());

		SetStyles(this.view, 
		{
			position: "absolute",
			top: "0px",
			left: "0px",
			height: "100%",
			width: "100%",
			backgroundColor: "rgba(0, 0, 0, 0.8)",
			color: "white",
			
			display: "flex",
			flexDirection: "column",
		  	alignItems: "center",
			justifyContent: "center",
			zIndex: ""+ ZIndex.Lock,
		});

		



		this.Hide();
	}

	public PrepareResources(resourceManager: IWriteOnlyResourceManager): void
	{
		//resourceManager.Add(new ImageResource(this.resourcesBasePath + "img/lock.png", this.resid.ScopedResourceName("lock")));
		resourceManager.AddGlobal(new ImageResource(this.commonBonusResourcesBasePath + "PopupFrame.png",
        ResourceIdentifier.Global.Add("PopupFrame").Scope()));
	}

	public ResourcesLoaded(resourceManager: IReadOnlyResourceManager): void {

		//Creat HTML
		//this.dialog.classList.add(this.resid.Add("dialog").Scope());
		this.dialog = CreateElement("div", {
			classes: ["popupdialog", this.resid.Scope()],
			parentToAppend: this.view,
			style: {
				width: "67%",
				height: "73%",
				backgroundColor: "black",
				color: "white",
				//borderRadius: Scale.XYpx(50),
				textAlign: "center",
				borderRadius: `${Scale.XYpx(60)}`,
				borderImage: resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add("PopupFrame")).CssBackground(),
				borderImageSlice: `${Scale.fh(60)} ${Scale.fh(60)} ${Scale.fh(60)} ${Scale.fh(60)}`,
				borderImageWidth: `${Scale.fh(30)} ${Scale.fh(30)} ${Scale.fh(30)} ${Scale.fh(30)}`,
				borderImageRepeat: "stretch stretch",
				borderStyle: "solid",
				display: "flex",
				flexDirection: "column",
				//justifyContent: "center",
				alignItems: "center",
				padding: Scale.fhpx(50),
				//lineHeight : Scale.fhpx(80),
			}
		});
		this.advertismentheader = CreateElement("div", {
			classes: ["advertismentheader", this.resid.Scope()],
			parentToAppend: this.dialog,
			style: {
				width: "100%",
				height: "30%",
				position: "relative",				
				alignItems: "center",
				justifyContent: "center",
				display:"flex",
			}
		});

		//this.titleContainer.classList.add(this.resid.Add("title").Scope());
		this.titleContainer = CreateElement("div", {
			classes: ["titlecontainer", this.resid.Scope()],
			parentToAppend: this.advertismentheader,
			style: {
				//this.titleContainer.style.height = "30%";
				width: "80%",
				//top: Scale.Ypx(0),//Scale.Ypx(-46),
				//position: "relative",
				fontSize: Scale.fhpx(50),
				//lineHeight : Scale.fhpx(50),
				borderBottomWidth: `${Scale.fhpx(5)}`,
				borderBottomStyle: "solid",
				borderBottomColor: "white",
				display: "flex",
				alignContent: "center",
				justifyContent: "center",
				
			}
		});
		this.titleContainer.innerHTML = "MACHINE LOCKED";
		//this.reasonContainer.classList.add(this.resid.Add("reason").Scope());
		this.reasonContainer = CreateElement("div", {
			classes: ["reasonContainer", this.resid.Scope()],
			parentToAppend: this.dialog,
			style: {
				height: "50%",
				width: "90%",
				fontSize: Scale.fhpx(50),
				//lineHeight: Scale.fhpx(50),
				display: "flex",
				position: "relative",
				alignContent: "center",
				justifyContent: "center",
			}
		});
		this.reasonContainer.innerHTML = "Belly door open (code 10)";
		//this.dialog.appendChild(this.titleContainer);
		//this.dialog.appendChild(this.reasonContainer);
		this.view.appendChild(this.dialog);
		//create controls view
		//this.controls.classList.add(this.resid.Add("controls").Scope());
		this.controls = CreateElement("div", {
			classes: ["controls", this.resid.Scope()],
			parentToAppend: this.dialog,
			style: {
				height: "20%",
				width: "93%",
				display: "flex",
				flexDirection: "row",
				fontSize: Scale.fhpx(50),
				alignContent: "center",
				justifyContent: "center",
				position: "relative",
				bottom: Scale.Ypx(0),
				//transform:"translate(0, -50%)",
			}
		});
		this.dialog.appendChild(this.controls);
	}


	
	protected ConstructButton(message : IPopupMessage): void
	{
		let buttonStyle: Partial<CSSStyleDeclaration> = {
            borderRadius: Scale.XYpx(16),
    
            border: `${Scale.XYpx(3)} solid gold`,
            //backgroundClip: "padding-box",
            borderStyle: "inset",
        
            margin: `${Scale.Wpx(5)} ${Scale.Hpx(10)}`,
            height: Scale.Hpx(100),
        
            display: "flex",
            justifyContent: "center",
			alignItems: "center",
        
            backgroundOrigin: "border-box",
            backgroundClip: "content-box, border-box",

			width: "20%"
		};

        message.Buttons?.forEach(button => {
			let createButton = CreateElement("div", {
				classes: ["button",button.Text],
				parentToAppend: this.controls,
				style: {
					...buttonStyle				
				}
			});
			createButton.textContent = button.Text;

			let buttonState: ButtonStatePopupMessage = {				
				element: createButton,		
				isPressed : false,  
				delayReleaseTime: this.systemContext.TimingContext().CreateTimeout(`Button-${button.Text}-delayrelease`, 250, () => {
					
					if (buttonState.releasePending)
					{
						this.AnimateButtonPress(buttonState, false);
					}
	
					buttonState.releasePending = false;
				}),
	
				releasePending: false,
				
			};
	
			this.buttonState.set(button, buttonState);
			
	
		  
			console.log("PopupMessge Button:",buttonState ,"element" , button );
	
			AddMouseDownListener(buttonState.element, () =>this.ButtonChanged(button,true));
			AddMouseUpListener(buttonState.element, () => this.ButtonChanged(button,false));
			//AddMouseLeaveListener(element, () => this.ButtonReleased(button));
	
		});
		

	
	}

	public ButtonChanged(button: MessageButton, pressed: boolean): void
    {
        if (pressed)
        {
            this.ButtonPressed(button);
			this.ButtonAction(button);
        }
        else
        {
            this.ButtonReleased(button);
        }
    }

	protected ButtonPressed(button: MessageButton): void {
		// Log.Debug("Panel", "Button " + button + " pressed");

		let buttonState = this.buttonState.get(button);
		if (buttonState) {

			// not pressed, press now
			if (!buttonState.isPressed) {
				buttonState.isPressed = true;
				buttonState.releasePending = false;
				buttonState.delayReleaseTime?.Start();
				

				this.AnimateButtonPress(buttonState, true);
			}
		}
		else {
			// no such button on PopupMessage
		}
	}

	protected ButtonReleased(button: MessageButton): void
	{
        // Log.Debug("Panel", "Button " + button + " released");
        
        
        let buttonState = this.buttonState.get(button);
        if (buttonState)
        {
            if (buttonState.isPressed)
            {
                // pressed, release now
                buttonState.isPressed = false;                

                if (buttonState.delayReleaseTime?.Running())
                {
                    buttonState.releasePending = true;
                }
                else
                {
                    this.AnimateButtonPress(buttonState, false);
                    buttonState.releasePending = false;
                }
            }
        }
        else
        {
            // no such button on PopupMessage
        }
	}

	protected AnimateButtonPress(buttonState: ButtonStatePopupMessage, pressed: boolean): void 
    {
        // press
        if (pressed)
        {
            SetStyles(buttonState.element, {
                transform: `translateY(${Scale.Ypx(-8)})`,
                //boxShadow: `${Scale.Xpx(0)} ${Scale.Ypx(5)} ${Scale.XYpx(16)} rgb(0,255 , 0)`,
            });

			//buttonState.action == "hide" ? this.Hide() : " ";
        }
        // release
        else
        {
            SetStyles(buttonState.element, {
                transform: "translateY(0px)",
                //boxShadow: "none",
            })
        }
	}

	protected ButtonAction(button: MessageButton) {
		if (button.Action == "continue") {
			this.Hide();
		} else if (button.Action == "quit") {
			this.titleContainer.innerHTML = "Attention player"
			this.reasonContainer.innerHTML = "Wait game will reload alone ..... ";
			setTimeout(() => window.location.reload(), 2000);
		} else if (button.Action == "cashier") {
			this.CallPayoutMenu();
			this.Hide();
		} else if (button.Action == "link") {
			if (button.LinkType == LinkType.Redirect) {
				window.location.replace(button.Link);
			}
			if (button.LinkType == LinkType.Ajax) { }
			if (button.LinkType == LinkType.AjaxReponse) { }
		}
	}


	public ShowPopupMessage(message : IPopupMessage )
	{
		this.titleContainer.innerHTML = message.Title;
		this.reasonContainer.innerHTML = message.Text;
		this.controls.innerHTML = ""		
		this.ConstructButton(message);
		this.Show();
		this.isLocked = true;
	}

	public Stop()
	{
		this.Hide();
		this.isLocked = false;
	}

	public IsLocked():boolean
	{
		return this.isLocked;
	}

	protected Show()
	{
		this.isLocked = true;
		this.view.style.visibility = "visible";
	}

	protected Hide()
	{
		this.view.style.visibility = "hidden";
		this.isLocked = false;
	}

	public View(): HTMLElement
	{
		return this.view;
	}	

	public CallPayoutMenu: CallPayoutMenuCallBack = null;
	
}
export type CallPayoutMenuCallBack = () => void;